<template>
  <div class="home-container bc-bgc">
    <van-nav-bar class="nav-bar" fixed placeholder>
      <!-- <template #left>
        <img
          :src="
            $store.getters.getBaseInfo.ico !== undefined
              ? $store.getters.getBaseInfo.ico
              : '/img/null.png'
          "
        />
      </template> -->
      <template #title>
        <img
          :src="
            $store.getters.getBaseInfo.ico !== undefined
              ? $store.getters.getBaseInfo.ico
              : '/img/null.png'
          "
          class="titleimg"
        />
      </template>
      <template #right>
        <div
          v-if="!is_login"
          class="m-md2-r ps3"
          @click="$router.push('/Register')"
        >
          <span>{{ $t("auth.no_account") }}</span>
        </div>
        <img
          @click="kefu()"
          class="w2 bc-w1"
          src="../../assets/bc-img/tall.png"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div class="home-scroll">
      <div class="banner">
        <swiper class="banner_swiper" :options="bannerSwiperOption">
          <swiper-slide v-for="(v, key) in banners" :key="key">
            <van-image class="banner_img" round :src="v.url">
              <template v-slot:loading>
                <van-loading type="circular" />
              </template>
            </van-image>
          </swiper-slide>
        </swiper>
      </div>
      <div class="notice-bar">
        <van-notice-bar
          class="notice-swipe"
          left-icon="volume-o"
          background="linear-gradient(to right,#332022,#271C2D)"
          color="#e7b58e"
          :text="this.notice"
        />
        <div class="linear-gradient"></div>
      </div>
      <!-- <ul class="index-nav m-flex m-f-top">
        <li
          @click="key != 5 ? $router.push(item.path) : toServicePage()"
          v-for="(item, key) in indexNav"
          :key="key"
        >
          <img :src="item.icon" alt="" />
          <p>{{ item.text }}</p>
        </li>
      </ul> -->
      <div class="m-flex m-f-top bc-flex">
        <div class="bc-choose">
          <div>{{ $t("index.Featured") }}</div>
          <div style="color: #fff; font-size: 1.3rem">
            {{ recommend.hot_count }}
          </div>
          <div
            style="
              color: #ccc;
              font-weight: lighter;
              font-size: 0.6rem !important;
            "
          >
            {{ $t("index.more") }}
          </div>
        </div>
        <div class="bc-choose">
          <div>{{ $t("index.focus") }}</div>
          <div style="color: #fff; font-size: 1.3rem">
            {{ recommend.recommend_count }}
          </div>
          <div
            style="
              color: #ccc;
              font-weight: lighter;
              font-size: 0.6rem !important;
            "
          >
            {{ $t("index.hot") }}
          </div>
        </div>
        <div class="bc-choose">
          <div>{{ $t("index.Entrance") }}</div>
          <div
            style="
              color: #fff;
              font-weight: lighter;
              font-size: 0.6rem !important;
            "
          >
            {{ $t("index.customer_service") }}
          </div>
          <button class="btn" @click="kefu()">
            {{ $t("index.contact") }}
          </button>
        </div>
      </div>

      <van-pull-refresh
        :pulling-text="$t('reservation.refresh')"
        :loosing-text="$t('reservation.refreshpage')"
        :loading-text="$t('reservation.refresh')"
        :success-text="$t('reservation.refresh')"
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <div class="hot-recommend">
          <div class="hot-title">{{ $t("index.Featured_list") }}</div>
          <div class="hot-title-div">
            <div>
              <span>{{ $t("index.hot") }}</span>
            </div>
            <div class="hot-right">
              <span @click="gotoMenu('/Choose')">{{
                $t("index.recmonmand")
              }}</span>
              <!-- <van-icon name="arrow" color="#979799" /> -->
            </div>
          </div>

          <!-- 核心：一行4个，仅显示2排（共8个） -->
          <div class="movie_list_0">
            <div
              class="movie-item"
              v-for="(v, key) in visibleFeaturedList"
              :key="key"
              @click="profile(v.id)"
            >
              <van-image
                class="movie-img"
                :src="v.img_url"
                fallback="/img/null.png"
              >
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
              <!-- <div class="name-text2">
                {{ $t("index.airborne") }}
              </div> -->
              <div class="name-text">
                {{ v.xuanfei_name || $t("No information yet") }}
              </div>
            </div>
          </div>
          <div class="hot-title">{{ $t("index.Private") }}</div>
          <div class="hot-title-div">
            <div>
              <span>{{ $t("index.more") }}</span>
            </div>
          </div>

          <div class="movie_list_1">
            <div
              class="movie-list-item"
              v-for="(v, key) in visiblePrivateList"
              :key="key"
              @click="toPlayVideo(v.id)"
            >
              <div class="renzheng">
                <span><img src="../../assets/bc-img/V.png" alt="" /></span
                >{{ $t("index.Certification") }}
              </div>
              <van-image class="cover_img" round :src="v.img_url">
                <template v-slot:loading>
                  <van-loading type="circular" />
                </template>
              </van-image>
              <p class="text-line2">{{ v.xuanfei_name }}</p>
            </div>
            <div class="hot-recommend-more" @click="nextList">
              {{ $t("index.next") }}
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loggedIn: !!localStorage.getItem("token"),
      notice: this.$t("index.loading"),
      banners: [{}],
      basicData: [],
      gameitem: [{}, {}, {}, {}],
      movielist_0: [{}, {}, {}, {}],
      movielist_1: [{}, {}, {}, {}, {}, {}, {}, {}],
      isLoading: false,
      movielistSwiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0,
        slidesPerGroup: 1,
      },
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "1",
        speed: 800,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
      xuan_fei: [],
      choose_page: 1,
      datalist: [],
      num: 4,
      hot_list: [], //热门列表
      recommend: [], //推荐列表
    };
  },
  computed: {
    is_login() {
      return this.loggedIn;
    },
    visibleFeaturedList() {
      return Array.isArray(this.xuan_fei) ? this.xuan_fei.slice(0, 10) : [];
    },
    visiblePrivateList() {
      return Array.isArray(this.datalist) ? this.datalist.slice(0, this.num) : [];
    },
    indexNav() {
      return {
        1: {
          icon: "/img/index_nav/0.png",
          text: this.$t("foorter.subscribe"),
          path: "/Game",
        },
        2: {
          icon: "/img/index_nav/1.png",
          text: this.$t("bulletin"),
          path: "/Notice",
        },
        3: {
          icon: "/img/index_nav/2.png",
          text: this.$t("foorter.Film"),
          path: "/Video",
        },
        4: {
          icon: "/img/index_nav/3.png",
          text: this.$t("concubine.concubine"),
          path: "/Choose",
        },
      };
    },
  },
  methods: {
    updateLoginState() {
      this.loggedIn = !!localStorage.getItem("token");
    },
    consumeRedirectTip() {
      const { redirect_tip, redirect_ts, ...restQuery } = this.$route.query || {};
      if (!redirect_tip) {
        return;
      }
      this.$nextTick(() => {
        if (redirect_tip === "contact_admin") {
          this.$toast(this.$t("reservation.contact_admin"));
        }
      });
      this.$router.replace({
        path: this.$route.path,
        query: restQuery,
      });
    },
    applyCachedHomeData() {
      const cache = localStorage.getItem("home_page_cache_tw");
      if (!cache) return false;
      try {
        const parsed = JSON.parse(cache);
        this.notice = parsed.notice || this.notice;
        this.banners = Array.isArray(parsed.banners) && parsed.banners.length
          ? parsed.banners
          : this.banners;
        this.xuan_fei = Array.isArray(parsed.xuan_fei) ? parsed.xuan_fei : [];
        this.datalist = Array.isArray(parsed.datalist) ? parsed.datalist : [];
        this.hot_list = Array.isArray(parsed.hot_list) ? parsed.hot_list : [];
        this.recommend = parsed.recommend || this.recommend;
        return true;
      } catch (error) {
        return false;
      }
    },
    persistHomeData() {
      localStorage.setItem(
        "home_page_cache_tw",
        JSON.stringify({
          notice: this.notice,
          banners: this.banners,
          xuan_fei: this.xuan_fei,
          datalist: this.datalist,
          hot_list: this.hot_list,
          recommend: this.recommend,
        })
      );
    },
    kefu() {
      this.$toast(this.$t("Universal.personal"));
    },
    async getjiaodianlist() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_API}/xuanfei/xuanfeilist`,
          {
            params: {
              with_stats: 1,
              page: 1,
              plain_json: 1,
            },
          }
        );
        // console.log("拿到的数据", res);
        this.recommend = res.data.data.stats;
        this.persistHomeData();
        // console.log("111", this.recommend);
      } catch (err) {}
    },
    getxiaojielist() {
      return this.$http({
        method: "get",
        url: "xuanfeilist",
        data: {
          page: this.choose_page,
        },
      }).then((res) => {
        const list = Array.isArray(res.data) ? res.data : [];
        if (list.length > 0) {
          if (this.choose_page === 1) {
            this.datalist = list;
          } else {
            this.datalist.push(...list);
          }
          this.persistHomeData();
        } else {
          this.choose_page -= 1;
        }
      });
    },
    profile(id) {
      this.$router.push({ path: "/profile?id=" + id });
    },
    getxuanfeilist() {
      return this.$http({
        method: "get",
        url: "xuanfeilist",
        data: {
          is_ranking: 1,
        },
      }).then((res) => {
        this.xuan_fei = Array.isArray(res.data) ? res.data : [];
        this.hot_list = [];
        this.xuan_fei.forEach((v, i) => {
          if (v.is_hot == 1) {
            this.hot_list.push(v);
            // console.log("热门列表", this.hot_list);
          }
        });
        this.persistHomeData();
      });
    },
    toServicePage() {
      const service = this.$store.getters.getBaseInfo;
      if (service.iskefu == 1) {
        window.location.href = service.kefu;
      }
    },
    nextList() {
      this.choose_page += 1;
      this.getxiaojielist();
      this.num += 4;
    },
    toLottery(key, id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "/Lottery?key=" + key + "&id=" + id });
      }
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "/profile?id=" + id });
      }
    },
    async onRefresh() {
      this.choose_page = 1;
      this.num = 4;
      this.datalist = [];
      try {
        await Promise.all([
          this.getBasicConfig(),
          this.getxuanfeilist(),
          this.getxiaojielist(),
          this.getjiaodianlist(),
        ]);
        this.$toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    getBasicConfig() {
      return this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
        this.getMovieList_0(this.basicData);
        this.getMovieList_1(this.basicData);
        this.persistHomeData();
        return this.getGameItem();
      });
    },
    getNotice(data) {
      this.notice = data.notice;
    },
    getGameItem() {
      return this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        this.gameitem = res.data;
      });
    },
    getMovieList_0(data) {
      this.movielist_0 = data.movielist_0;
    },
    getMovieList_1(data) {
      this.movielist_1 = data.movielist_1;
    },
    getBanner(data) {
      this.banners = data.banners;
    },
    gotoMenu(index) {
      this.$router.push(index);
    },
  },
  created() {
    this.updateLoginState();
    this.consumeRedirectTip();
    this.applyCachedHomeData();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getxiaojielist();
    this.getjiaodianlist();
  },
  activated() {
    this.updateLoginState();
  },
};
</script>

<style lang='less' scoped>
@import "@/assets/css/base.less";
// @notice-bar-size: 30px;
.titleimg {
    width: 96px;
    max-height: 34px;
    object-fit: contain;
    border: 0 !important;
}

::v-deep .van-notice-bar__content {
  font-size: 0.8rem;
  font-weight: lighter !important;
}
::v-deep .van-pull-refresh {
  padding-bottom: 5rem;
}

.index-nav {
  margin: @md1;
  padding: @pd1;
  height: auto;
  text-align: center;
  color: @theme2;
  border: 1px solid @theme2;
  border-radius: @br1;
  font-size: 0.8rem;
  & > li {
    flex: 1;
  }
  p {
    margin: 0;
  }
  img {
    height: 3em;
  }
}

.linear-bg {
  height: 200px;
  background: linear-gradient(270deg, #988fba, #f487e0);
}

.home-container {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
}
.bc-bgc {
  background: linear-gradient(to bottom right, #1f1327, #1d1222) !important;
}

// .linear-gradient {
//   width: 100%;
//   height: 2px;
//   background: linear-gradient(
//     to right,
//     rgba(126, 86, 120, 0),
//     rgb(230, 195, 161),
//     rgba(126, 86, 120, 0)
//   );
// }

::v-deep .van-notice-bar__left-icon,
.van-notice-bar__right-icon {
  min-width: 40px;
}

.notice-swipe {
  width: 100%;
  height: 85px;
  // font-size: @notice-bar-size;
  font-size: 1rem;
  ::v-deep .van-notice-bar__left-icon {
    font-size: 1.6rem;
    font-weight: lighter !important;
    margin-right: 0.5rem;
    margin-left: 0.5rem;
  }
}

.notice-bar {
  margin: @md1 0;
  border: 1px solid #4a4a4a;
  border-radius: 10rem;
  overflow: hidden;
  /deep/ .notice-swipe {
    height: 2.5em;
  }
}

::v-deep .van-icon-bullhorn-o::before {
  transform: scale(2.5);
}

.banner {
  width: 100%;
}

.banner_swiper {
  height: 100%;
  width: 100%;
  border-radius: 1rem;
  .swiper-slide {
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 620px;
    height: 300px;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    background-color: #ffffff;
    background-position: center;
    background-size: cover;
    color: #ffffff;
  }
}

::v-deep .swiper-container-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0)
  );
}
::v-deep .swiper-container-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0)
  );
}

.banner_img {
  border-radius: 10px;
  width: 100%;
  height: 100%;
}

.hot-game {
  width: 100%;
  height: 100%;
}

.hot-title-div {
  // width: calc(100% - 50px);
  margin: 0 0.5rem;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // background-color: @theme1;
  // padding: @pd1;
}
.hot-title-div > div:first-child {
  width: 430px;
}
.hot-title-div div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.hot-title-div > div:nth-child(2) span {
  font-size: 20px;
  color: #979799;
}
.hot-title-div > div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 35px;
  font-weight: lighter !important;
  color: #fff;
}
// .hot-title-div > div:first-child span:before {
//   content: "";
//   display: block;
//   width: 5px;
//   height: 30px;
//   background-color: @theme2;
//   border-radius: 1px;
//   margin-right: 5px;
// }

.hot-game .hot-items-div {
  margin: @md1;
}
.hot-game .hot-items-div span {
  margin-top: 10px;
  font-size: 28px;
  color: @theme2;
}

.hot-recommend {
  width: 100%;
  flex: 1;
  .hot-title {
    color: #75675d;
    font-weight: lighter !important;
    font-size: 0.7rem;
    padding: 0.5rem 0.5rem 0 0.5rem;
  }
  .hot-right {
    background: linear-gradient(to bottom right, #3e2f5a, #4b3640);
    width: auto;
    display: flex;
    justify-content: center;
    padding: 0.4rem 1rem;
    border-radius: 2rem;
    span {
      color: #c6b98b !important;
      font-weight: lighter !important;
    }
  }
}

.movie_list_0 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px 15px;
  gap: 10px;
  color: #fff;
  max-height: calc((100vw / 4 - 10px) * 1.4 * 2 + 10px); /* 限制高度为2排 */
  overflow: hidden; /* 隐藏超出2排的内容 */
}
.movie-item {
  width: calc(25% - 45px); /* 一行4个 */
  position: relative;
}
.movie-img {
  width: 100%;
  height: 5rem; /* 恢复图片高度，解决消失问题 */
  aspect-ratio: 4/4; /* 图片比例，可调整 */
  border-radius: 20px;
  overflow: hidden;
}
::v-deep .movie-img .van-image__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.name-text {
  position: absolute;
  bottom: 6px;
  left: 0;
  right: 0;
  text-align: left;
  font-size: 20px;
  color: #fff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);
  z-index: 1;
  padding: 1rem 0.5rem 0.2rem 0.5rem;
}
.name-text2 {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  text-align: left;
  font-size: 18px;
  color: #f4c491;
  z-index: 1;
  padding: 0 0.5rem;
  background-color: rgba(92, 90, 10, 0.4);
  border-radius: 2rem;
  width: 2.5rem;
  margin-left: 0.3rem;
  font-weight: lighter !important;
}

.movie_list_1 {
  display: block;
  width: calc(100% - 20px);
  margin: 0 auto;
}
.movie_list_1 .movie-list-item {
  width: 100%;
  margin: @md1 0;
  color: @white;
  p {
    margin: 0;
  }
  .renzheng {
    width: 5vm;
    padding: 0.5rem 1rem;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 2rem;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    z-index: 10;
    right: 30px;
    font-weight: lighter !important;
    margin-top: 0.6rem;
    font-size: 20px;
    span {
      display: flex;
      align-items: center;
    }
    img {
      width: 30px;
    }
  }
}
.movie_list_1 .movie-list-item .cover_img {
  border-radius: 1.5rem;
  width: 100%;
  height: 400px;
  ::v-deep .van-image__img {
    object-fit: cover;
    object-position: center center;
  }
}

.home-scroll {
  // padding-bottom: 110px;
  padding: 0.5rem;
}

.hot-recommend-more {
  width: 100%;
  padding-bottom: 20px;
  text-align: center;
  color: #979799;
  font-size: 30px;
}

/deep/ .van-grid-item__content {
  background-color: @theme1;
  color: @theme2;
}
::v-deep .hot-items-div .game_item_img .van-image__img {
  border-radius: 20px;
}
::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}
.bc-flex {
  display: flex;
  justify-content: space-between;
  padding: 0 0.5rem;
}
.bc-w1 {
  width: 40px !important;
  height: 40px !important;
}
.bc-choose {
  width: 32%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  color: #e7a761;
  font-size: 0.7rem;
  border: 1px solid #444;
  padding: 0.8rem;
  border-radius: 1rem;
  background-color: #1a1a1a;
  .btn {
    background-color: #e7a761;
    color: #000;
    padding: 0.2rem 0.6rem;
    border-radius: 3rem;
    margin-top: 8px;
  }
}
</style>
